import { Switch, Table, TextField, useTable } from "@pankod/refine-antd";
import { IResourceComponentsProps } from "@pankod/refine-core";
import { updateAllowToSubscribeSubscription } from "apis/contributorSubscriptionPool/updateAllowToSubscribeSubscription";
import React, { useEffect, useState } from "react";
import { formatNumberWith2DecimalPlaces } from "utils";

export const ContributorSubscriptionPoolList: React.FC<
  IResourceComponentsProps
> = () => {
  const [allowSubscribeSubscription, setAllowSubscribeSubscription] =
    useState<any>(null);
  const { tableProps }: any = useTable<any>({
    resource: "contributor-subscription-pool",
  });

  const onChange = async (allowToSubscribeSubscription: boolean) => {
    setAllowSubscribeSubscription(allowToSubscribeSubscription);
    await updateAllowToSubscribeSubscription(allowToSubscribeSubscription);
  };

  useEffect(() => {
    if (tableProps?.dataSource?.[0]) {
      setAllowSubscribeSubscription(
        tableProps?.dataSource?.[0]?.allowToSubscribeSubscription
      );
    }
  }, [tableProps?.dataSource]);

  return (
    <>
      {typeof allowSubscribeSubscription == "boolean" && (
        <div style={{ display: "flex", gap: "10px", marginBottom: "10px" }}>
          <h5 style={{ fontSize: "14px" }}>Show Subscription menu on WEB</h5>
          <Switch
            onChange={(value) => onChange(value)}
            checked={allowSubscribeSubscription}
          />
        </div>
      )}

      <Table {...tableProps} pagination={false} rowKey="id">
        <Table.Column
          dataIndex="totalSubscriptionBasedDownloads"
          key="totalSubscriptionBasedDownloads"
          title="Total Subscription Based Downloads"
          render={(value) => <TextField value={value} />}
        />
        <Table.Column
          dataIndex="cashValue"
          key="cashValue"
          title="Cash Value($)"
          render={(value) => (
            <TextField value={formatNumberWith2DecimalPlaces(value)} />
          )}
        />
        <Table.Column
          dataIndex="perDownloadValue"
          key="perDownloadValue"
          title="Per-Download Value($)"
          render={(value) => (
            <TextField value={formatNumberWith2DecimalPlaces(value)} />
          )}
        />
      </Table>
    </>
  );
};
